<app-header> </app-header>
<ion-content id="food-cost" class="gray-content-bg" scroll-y="false">
  <div
    *ngIf="(viewModel$ | async) as viewModel"
    class="scroll-container"
    data-cy="scroll-container"
    cdkVirtualScrollingElement
  >
    <div class="header-container">
      <ion-grid
        data-cy="food-cost-header"
        class="food-cost-header"
        [class.desktop]="foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum.desktop"
        [class.mobile]="foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum.mobile"
        [class.tablet]="foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum.tablet"
        [fixed]="true"
      >
        <ng-container
          *ngIf="foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum.desktop"
          [ngTemplateOutlet]="DesktopHeader"
          [ngTemplateOutletContext]="{ viewModel: viewModel }"
        >
        </ng-container>
        <ng-container
          *ngIf="foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum.tablet"
          [ngTemplateOutlet]="TabletHeader"
          [ngTemplateOutletContext]="{ viewModel: viewModel }"
        >
        </ng-container>
        <ng-container
          *ngIf="foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum.mobile"
          [ngTemplateOutlet]="MobileHeader"
          [ngTemplateOutletContext]="{ viewModel: viewModel }"
        >
        </ng-container>
      </ion-grid>
    </div>

    <ion-grid data-cy="food-cost-grid" class="food-cost-grid" [fixed]="true">
      <ion-row *ngIf="viewModel?.showFoodCostRange">
        <ion-col size="12">
          <div
            class="target-range-container"
            [class.mobile-range-container]="foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum?.mobile"
          >
            <p class="target-range-title bold">
              {{ 'i18n.inventory.foodCost.rangeTitle' | translate }}
            </p>
            <div
              class="range-container"
              *ngIf="foodCostRangeLoadingState$ | async as foodCostRangeLoadingState"
            >
              <div class="input-save-container">
                <ion-input
                  class="range-input"
                  [value]="startRangeIsBeingInteracted ? startRangeValue : startRangeValue ? startRangeValue + '%' : undefined"
                  [class.error]="!viewModel.foodCostRange || rangeHasChanged || (foodCostRangeLoadingState === foodCostRangeLoadingStateRef.error && saveButtonHasBeenClicked && !rangeHasChanged)"
                  [class.success]="foodCostRangeLoadingState === foodCostRangeLoadingStateRef.success && saveButtonHasBeenClicked && !rangeHasChanged"
                  [placeholder]="'1%'"
                  inputmode="numeric"
                  (ionBlur)="startRangeIsBeingInteracted = false"
                  (ionFocus)="startRangeIsBeingInteracted = true"
                  (ionChange)="handleStartRangeChange($event, viewModel)"
                  percentageDirective
                ></ion-input>
                <span>{{ 'i18n.inventory.foodCost.to' | translate }}</span>
                <ion-input
                  class="range-input"
                  [value]="endRangeIsBeingInteracted ? endRangeValue : endRangeValue ? endRangeValue + '%' : undefined"
                  [class.error]="!viewModel.foodCostRange || rangeHasChanged || (foodCostRangeLoadingState === foodCostRangeLoadingStateRef.error && saveButtonHasBeenClicked && !rangeHasChanged)"
                  [class.success]="foodCostRangeLoadingState === foodCostRangeLoadingStateRef.success && saveButtonHasBeenClicked && !rangeHasChanged"
                  [placeholder]="'100%'"
                  inputmode="numeric"
                  (ionBlur)="endRangeIsBeingInteracted = false"
                  (ionFocus)="endRangeIsBeingInteracted = true"
                  (ionChange)="handleEndRangeChange($event, viewModel)"
                  percentageDirective
                ></ion-input>
                <ion-button
                  class="usf-outline-green-button"
                  (click)="handleRangeSave()"
                  [disabled]="!startRangeValue || !endRangeValue"
                >
                  <span
                    *ngIf="foodCostRangeLoadingState !== foodCostRangeLoadingStateRef.loading"
                    >{{'i18n.common.save' | translate}}</span
                  >
                  <ion-spinner
                    *ngIf="foodCostRangeLoadingState === foodCostRangeLoadingStateRef.loading"
                    name="circles"
                    data-cy="loading-spinner-icon"
                  ></ion-spinner>
                </ion-button>
              </div>
              <div class="input-message">
                <p *ngIf="rangeHasChanged" class="error">
                  {{ 'i18n.inventory.foodCost.rangeChangesNotSaved' | translate
                  }}
                </p>
                <p
                  *ngIf="foodCostRangeLoadingState === foodCostRangeLoadingStateRef.error && saveButtonHasBeenClicked && !rangeHasChanged"
                  class="error"
                >
                  {{ 'i18n.inventory.foodCost.rangeChangesFail' | translate }}
                </p>
                <p
                  *ngIf="foodCostRangeLoadingState === foodCostRangeLoadingStateRef.success && saveButtonHasBeenClicked && !rangeHasChanged"
                  class="success"
                >
                  {{ 'i18n.inventory.foodCost.rangeChangesSuccess' | translate
                  }}
                </p>
                <p
                  *ngIf="!viewModel.foodCostRange && !rangeHasChanged"
                  class="error"
                >
                  {{ 'i18n.inventory.foodCost.rangeNeedValue' | translate }}
                </p>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-item-divider *ngIf="viewModel?.showFoodCostRange"></ion-item-divider>

      <!-- Food Cost Reports Exist -->
      <ion-row
        class="reports-header"
        *ngIf="viewModel?.foodCostReports?.length > 0"
      >
        <ion-col>
          <div class="title-container">
            <p class="title">
              {{'i18n.inventory.foodCost.pageTitle' | translate}}
            </p>
            <ion-button
              class="usf-fill-green-button"
              (click)="openFoodCostModal()"
            >
              {{'i18n.inventory.foodCost.createNewButton' | translate}}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>

      <!-- No Food Cost Reports Exist -->
      <ion-row *ngIf="viewModel?.foodCostReports?.length === 0">
        <ion-col>
          <p class="data-missing-title">
            {{'i18n.inventory.foodCost.pageTitle' | translate}}
          </p>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="viewModel?.foodCostReports?.length === 0">
        <ion-col>
          <p
            class="data-missing-message"
            [class.mobile]="foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum.mobile"
          >
            {{'i18n.inventory.foodCost.dataMissingMessage' | translate}}
          </p>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="viewModel?.foodCostReports?.length === 0">
        <ion-col class="center-any-object">
          <ion-button
            class="usf-fill-green-button"
            (click)="openFoodCostModal()"
          >
            {{'i18n.inventory.foodCost.createNewButton' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>

      <!-- Sorting Headers - Desktop/Tablet -->
      <ion-row
        class="sort-header"
        *ngIf="viewModel?.foodCostReports?.length > 0 && foodCostCalculatorService.platformService.platformType !== foodCostCalculatorService.platformService.platformEnum.mobile"
      >
        <ion-col size="2.95" offset="0.16">
          <app-sortable-section-carets
            [displayText]="viewModel?.sortOptions?.dateRange?.displayText"
            [headerName]="viewModel?.sortOptions?.dateRange?.headerName"
            [selectedHeader]="viewModel?.sortOptions?.selectedHeader"
            [sortDirection]="viewModel?.sortOptions?.dateRange?.sortDirection"
            (sortClickEmitter)="handleSortClick($event)"
          ></app-sortable-section-carets>
        </ion-col>
        <ion-col size="3">
          <app-sortable-section-carets
            [displayText]="viewModel?.sortOptions?.dateCreated?.displayText"
            [headerName]="viewModel?.sortOptions?.dateCreated?.headerName"
            [selectedHeader]="viewModel?.sortOptions?.selectedHeader"
            [sortDirection]="viewModel?.sortOptions?.dateCreated?.sortDirection"
            (sortClickEmitter)="handleSortClick($event)"
          ></app-sortable-section-carets>
        </ion-col>
        <ion-col size="2.5">
          <app-sortable-section-carets
            [displayText]="viewModel?.sortOptions?.foodCostPercentage.displayText"
            [headerName]="viewModel?.sortOptions?.foodCostPercentage.headerName"
            [selectedHeader]="viewModel?.sortOptions?.selectedHeader"
            [sortDirection]="viewModel?.sortOptions?.foodCostPercentage.sortDirection"
            (sortClickEmitter)="handleSortClick($event)"
          ></app-sortable-section-carets>
        </ion-col>
        <ion-col>
          <div class="sort-header-text">
            <span class="medium-font-weight" data-cy="target-display-text"
              >{{ viewModel?.sortOptions?.target?.displayText | translate
              }}</span
            >
          </div>
        </ion-col>
      </ion-row>

      <!-- Sorting Headers - Mobile -->
      <ion-row
        class="sort-header"
        *ngIf="viewModel?.foodCostReports?.length > 0 && foodCostCalculatorService.platformService.platformType === foodCostCalculatorService.platformService.platformEnum.mobile"
      >
        <ion-col size="6.8" offset=".6">
          <div class="sort-header-text-mobile">
            <span class="medium-font-weight" data-cy="date-range-display-text"
              >{{ viewModel?.sortOptions?.dateRange?.displayText | translate
              }}</span
            >
          </div>
        </ion-col>
        <ion-col>
          <div class="sort-header-text-mobile">
            <span
              class="medium-font-weight"
              data-cy="food-cost-percentage-display-text"
              >{{ viewModel?.sortOptions?.foodCostPercentage?.displayText |
              translate }}</span
            >
          </div>
        </ion-col>
      </ion-row>

      <cdk-virtual-scroll-viewport
        data-cy="food-cost-scroll"
        class="cdk-scroll"
        orientation="vertical"
        itemSize="{{ viewModel?.itemSize }}"
      >
        <div
          *cdkVirtualFor="
          let foodCostReport of viewModel?.foodCostReports;
          let i = index;
          trackBy: trackItem
        "
          class="card-wrapper"
        >
          <app-food-cost-card
            [foodCostReport]="foodCostReport"
            [platform]="platformService?.platformType"
            (ellipsisClickEmitter)="openCostReportCardEllipsis($event)"
            (cardClickEmitter)="openCostReportDetailsCard($event)"
          >
          </app-food-cost-card>
        </div>
      </cdk-virtual-scroll-viewport>
    </ion-grid>
    <app-footer></app-footer>
    <app-food-cost-modal-container
      (submitEvent)="handleModalSubmission($event)"
      [translateService]="translateService"
      [datePipe]="datePipe"
      [isLoading$]="foodCostCalculatorService.isLoading$"
      [foodCostRangeExists]="viewModel.hasFoodCostRange"
      [inventories]="inventoriesForFoodCostModal$"
      (foodPurchaseDataRequest)="requestFoodPurchaseDataUpdate($event)"
    ></app-food-cost-modal-container>

    <app-food-cost-report-delete-modal
      [foodCostReport]="foodCostCalculatorService.selectedFoodCostReport.value"
    >
    </app-food-cost-report-delete-modal>

    <app-food-cost-report-details
      [foodCostReport]="foodCostCalculatorService.selectedFoodCostReport.value"
    >
    </app-food-cost-report-details>
  </div>
</ion-content>

<ng-template #DesktopHeader let-viewModel="viewModel">
  <ion-row>
    <ion-col size="12" class="margin-top">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <h1 class="title desktop">
        {{'i18n.inventory.foodCost.title' | translate | uppercase}}
      </h1>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="4.75">
      <app-overview-tile
        [overviewData]="viewModel?.overviewData"
        [platform]="foodCostCalculatorService.platformService.platformType"
        class="overview desktop"
      ></app-overview-tile>
    </ion-col>
    <ion-col size="6.75" offset="0.5">
      <app-graph-tile
        [graphData$]="foodCostCalculatorService.graphData$"
        [foodCostRange$]="foodCostCalculatorService.range$"
        [platform]="foodCostCalculatorService.platformService.platformType"
        class="graph desktop"
      ></app-graph-tile>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #TabletHeader let-viewModel="viewModel">
  <ion-row>
    <ion-col size="12">
      <h1 class="title tablet">
        {{'i18n.inventory.foodCost.title' | translate | uppercase}}
      </h1>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="4.4">
      <app-overview-tile
        [overviewData]="viewModel?.overviewData"
        [platform]="foodCostCalculatorService.platformService.platformType"
        class="overview tablet"
      ></app-overview-tile>
    </ion-col>
    <ion-col size="7.4" offset="0.2">
      <app-graph-tile
        [graphData$]="foodCostCalculatorService.graphData$"
        [foodCostRange$]="foodCostCalculatorService.range$"
        [platform]="foodCostCalculatorService.platformService.platformType"
        class="graph tablet"
      ></app-graph-tile>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #MobileHeader let-viewModel="viewModel">
  <ion-row>
    <ion-col size="12">
      <h1 class="title mobile">
        {{'i18n.inventory.foodCost.title' | translate | uppercase}}
      </h1>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <app-overview-tile
        [overviewData]="viewModel?.overviewData"
        [platform]="foodCostCalculatorService.platformService.platformType"
        class="overview mobile"
      ></app-overview-tile>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <app-graph-tile
        [graphData$]="foodCostCalculatorService.graphData$"
        [foodCostRange$]="foodCostCalculatorService.range$"
        [platform]="foodCostCalculatorService.platformService.platformType"
        class="graph mobile"
      ></app-graph-tile>
    </ion-col>
  </ion-row>
</ng-template>

<div *ngIf="(foodPurchaseData$ | async) as foodPurchaseData"></div>
